// Masks free-text input to a valid dollar amount: digits with at most one
// decimal point and at most two decimal places ("1234.56"). Pasted values
// like "$1,234.567" come out as "1234.56".
const maskAmount = (raw) => {
  const cleaned = raw.replace(/[^0-9.]/g, '');
  const [whole, ...decimals] = cleaned.split('.');
  if (decimals.length === 0) return whole;
  return `${whole}.${decimals.join('').slice(0, 2)}`;
};

export default maskAmount;
